import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    alreadyDisputed: 'This transaction has already been disputed on {date}',
    dispute: 'Dispute this transaction',
    moreHelp: 'Get more help',
  },
  fr: {
    alreadyDisputed: 'Cette opération a déjà été contestée le {date}',
    dispute: 'Contester cette opération',
    moreHelp: 'Obtenir plus d’aide',
  },
} as const);

export default locales;
